import React, { ReactNode } from 'react'
import './Greeting.scss'
import { Label } from '@ds.e/react'
import '@ds.e/scss/lib/Label.css'

export interface GreetingProps {
    greetingContainerClassName?: string
    titleContainerClassName?: string
    subTitleContainerClassName?: string
    title?: string
    subtitle?: string
    children?: ReactNode
}

type ContainerProps = {
    className?: string
    children: ReactNode
}

const GreetingContainer = ({ className, children }: ContainerProps) => (
    <div className={className}>{children}</div>
)

const TitleContainer = ({ className, children }: ContainerProps) => (
    <div className={className}>{children}</div>
)

const SubTitleContainer = ({ className, children }: ContainerProps) => (
    <div className={className}>{children}</div>
)

const Greeting: React.FC<GreetingProps> = ({
    greetingContainerClassName = '',
    titleContainerClassName = '',
    subTitleContainerClassName = '',
    title = '',
    subtitle = '',
    children = null,
}) => {
    return (
        <GreetingContainer className={greetingContainerClassName}>
            <TitleContainer className={titleContainerClassName}>
                <Label as="h4">{title}</Label>
            </TitleContainer>
            {children}
            <SubTitleContainer className={subTitleContainerClassName}>
                <Label>{subtitle}</Label>
            </SubTitleContainer>
        </GreetingContainer>
    )
}

export default Greeting
